module.exports = __webpack_public_path__ + "static/media/sofa-5.e922a0b5.webp";